import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TTransactionsData, TTransactionsStore } from './types';

// ==========================================:
const getTransactionsState = (state: TStoreState): TTransactionsStore => state.transactions;
export const getTransactions = getTransactionsState;

// ====================================================:
export const getTransactionsIsLoad = createSelector(
	[getTransactions],
	(transactions: TTransactionsStore): boolean => transactions.transactionsLoader,
);

// ====================================================:
export const getTransactionsList = createSelector(
	[getTransactions],
	(transactions: TTransactionsStore): TTransactionsData => transactions.transactions,
);
